import React from "react";

const StatCard = ({ icon, color, title, value, subtext, trend }) => {
  const styles = {
    blue: "bg-blue-100 text-blue-800 border-blue-200",
    green: "bg-emerald-100 text-emerald-800 border-emerald-200",
    red: "bg-rose-100 text-rose-800 border-rose-200",
    orange: "bg-amber-100 text-amber-800 border-amber-200",
  };
  return (
    <div
      tabIndex="0"
      aria-label={`${title}: ${value}. ${subtext}`}
      className={`bg-white border border-slate-200 p-5 rounded-2xl flex items-center gap-4 group hover:shadow-md transition-all focus-visible:ring-2 focus-visible:ring-blue-500 focus-visible:outline-none ${
        color === "red" ? "border-l-4 border-l-rose-500" : ""
      }`}
    >
      <div
        className={`w-12 h-12 rounded-xl flex items-center justify-center text-lg group-hover:scale-105 transition-transform border shrink-0 ${styles[color]}`}
      >
        <i className={`fa-solid ${icon}`} aria-hidden="true"></i>
      </div>
      <div className="min-w-0 flex-1">
        <p className="text-xs text-slate-500 font-bold uppercase tracking-wider truncate">{title}</p>
        <h3 className="text-2xl md:text-3xl font-extrabold text-slate-900 tracking-tight mt-0.5">{value}</h3>
        <p className={`text-xs ${trend === "up" ? "text-emerald-700 font-bold" : "text-slate-500 font-medium"} truncate mt-0.5`}>
          {subtext}
        </p>
      </div>
    </div>
  );
};

export default StatCard;
